// Version info - update VERSION on releases
export const VERSION = '1.5.0';
// BUILD_DATE is injected at build time via VITE_BUILD_DATE env var (set by GitHub Actions)
// For local development, we use a fixed string to avoid changing on every page refresh
export const BUILD_DATE = import.meta.env.VITE_BUILD_DATE || 'development';